/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import sortBy from 'lodash/sortBy';
import {
  Table,
  TableColumn,
  TableHeaderColumn,
} from '@alefeducation/ui-elements-library-core';
import AssignmentContext from '../../../common/AssignmentContext/AssignmentContext';
import { filterBySelectedTeam } from '../../helpers';
import { useStudentListContext } from '../StudentListContext';
import { useCommonSectionItemElements } from '../useCommonSectionItemElements';
import {
  fileColumn,
  gradeColumn,
  resubmissionColumn,
  returnDateColumn,
  studentColumn,
  submissionDateColumn,
} from './commonStudentSectionColumns';
import { NewStudentListSection } from './StudentListSection/NewStudentListSection';
import { actionColumnWidth } from './constants';

export const NewReturnedSubmissionsSection = () => {
  const { t } = useTranslation();
  const {
    groupedSubmissions,
    onViewStudent,
    dueOn,
    attachmentRequired,
  } = useStudentListContext();
  const {
    filters: { selectedTeamMembersIds, selectedTeamFilter },
  } = useContext(AssignmentContext);

  let { returned } = groupedSubmissions;

  returned =
    returned &&
    filterBySelectedTeam(selectedTeamFilter, selectedTeamMembersIds, returned);

  const sectionItems =
    returned &&
    sortBy(returned, ({ student }) => student.name).map(
      ({ student, submission, resubmission }) => ({
        ...student,
        submission,
        resubmission,
      }),
    );
  const sectionItemsTable =
    returned.length > 0 ? (
      <Table
        rows={sectionItems}
        columns={[
          studentColumn(t),
          { ...submissionDateColumn(dueOn, t) },
          { ...returnDateColumn(t) },
          { ...fileColumn(attachmentRequired, t, '126px') },
          { ...resubmissionColumn(t) },
          { ...gradeColumn(t, '364px') },
          {
            key: 'id',
            name: t('Actions'),
            renderColumn: ({ row }) => {
              const { viewIcon } = useCommonSectionItemElements(
                row,
                row.submission,
              );
              return (
                <TableColumn
                  row={row}
                  isFirstColumn={false}
                  className="actions-cell"
                >
                  <div className="actions-container">
                    {viewIcon(row, onViewStudent)}
                  </div>
                </TableColumn>
              );
            },
            renderHeaderColumn: rows => (
              <TableHeaderColumn
                isFirstColumn={false}
                rows={rows}
                width={actionColumnWidth}
              >
                <div className="col-heading">{t('Actions')}</div>
              </TableHeaderColumn>
            ),
            alignText: 'right',
            width: actionColumnWidth,
            height: '44px',
          },
        ]}
        isSticky={true}
        translationKeys={t}
      />
    ) : null;

  return (
    <NewStudentListSection
      data-testid="returned-section"
      submissions={returned}
      labelColor={'#BCEAE9'}
      sectionName={t('Returned')}
      sectionItems={sectionItemsTable}
    />
  );
};
